/** Mirrors backend Laura Gather brief cap (`listingAiContextSummary`). */
export const LAURA_LISTING_AI_CONTEXT_MAX_CHARS = 50_000;

export type LauraServicePageContextFields = {
	categoryTitle?: string;
	sectorTitles?: string[];
	listingRole?: "parent" | "child";
	parentListingTitle?: string;
	excerpt?: string;
};
